import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-quantify',
  styleUrl: 'lab-ds-quantify.css',
  shadow: true,
})
export class LabDsQuantify {
  @Prop() maxValue: number;

  @Prop() value: number = 0;

  @Event() handleCounterValue: EventEmitter<number>;

  handleIncreaseValueEmit() {
    this.handleCounterValue.emit(this.value + 1);
  }

  handleDecreaseValueEmit() {
    this.handleCounterValue.emit(this.value - 1);
  }

  render() {
    return (
      <div class="v4-quantify">
        <button disabled={this.value < 1} onClick={() => this.handleDecreaseValueEmit()}>
          <lab-ds-icon-not-selectable icon="remove" size="small" />
        </button>
        <div class="v4-quantify-counter">
          <span class="v4-quantify-option-counter">{this.value}</span>
          {this.maxValue && <span class="v4-quantify-option-divides">/</span>}
          {this.maxValue && <span class="v4-quantify-option-max-item">{this.maxValue}</span>}
        </div>
        <button disabled={this.value >= this.maxValue} onClick={() => this.handleIncreaseValueEmit()}>
          <lab-ds-icon-not-selectable icon="add" size="small" />
        </button>
      </div>
    );
  }
}
